import { RouteObject } from "react-router-dom";
import { defaultEmptyFun } from "../../utils/helper";
import { R_GeneralElementsRoutes } from "../../utils/Routes";
import { lazy, Suspense } from "react";
import SuspenseWrapper from "../../components/CustomLazyLoading/CustomLazyLoading";
import LoadingInstant from "../../pages/Utilities/LoadingInstant";

const LoginWithBiometric = lazy(
  () => import("./CaptureBiometric/CaptureBiometric")
);
const SetupMpn = lazy(() => import("./SetupMpn/SetupMpn"));
const NotificationsPage = lazy(
  () => import("./NotificationsPage/NotificationsPage")
);
const BasicSearch = lazy(() => import("./BasicSearch/BasicSearch"));
const AppTracker = lazy(() => import("./AppTracker/AppTracker"));
const TaxCenter = lazy(() => import("./TaxCenter/TaxCenter"));

const GeneralAppElementsRoutes: RouteObject[] = [
  {
    path: R_GeneralElementsRoutes.setMpin,
    element: <SuspenseWrapper LazyLoadingComponent={SetupMpn} />,
  },
  {
    path: R_GeneralElementsRoutes.biometric_setup,
    element: <SuspenseWrapper LazyLoadingComponent={LoginWithBiometric} />,
  },
  {
    path: R_GeneralElementsRoutes.search,
    element: <SuspenseWrapper LazyLoadingComponent={BasicSearch} />,
  },
  {
    path: R_GeneralElementsRoutes.notifications,
    element: (
      <Suspense fallback={<LoadingInstant />}>
        <NotificationsPage open={true} handleOpen={defaultEmptyFun} />
      </Suspense>
    ),
  },
  {
    path: R_GeneralElementsRoutes.appTracker,
    element: <SuspenseWrapper LazyLoadingComponent={AppTracker} />,
  },
  {
    path: R_GeneralElementsRoutes.taxCenter,
    element: <SuspenseWrapper LazyLoadingComponent={TaxCenter} />,
  },
];
export default GeneralAppElementsRoutes;
